<div class="relative">
  <label *ngIf="label" class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
    {{ label }} <span *ngIf="required" class="text-rose-500">*</span>
  </label>
  <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
    <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">{{ icon }}</span>
    <input type="text" [(ngModel)]="searchText" (focus)="onFocus()" (input)="onInput()" (blur)="onBlur()"
      [readonly]="disabled" [placeholder]="placeholder"
      class="w-full h-full pl-10 pr-10 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-60">
    <button *ngIf="selectedId && !disabled" type="button" (mousedown)="clearSelection($event)"
      class="absolute right-3 text-slate-400 hover:text-rose-500">
      <span class="material-icons text-lg">close</span>
    </button>
  </div>
  <p class="text-[11px] text-slate-400 mt-1">{{ hintText }}</p>

  <div *ngIf="isOpen && !disabled"
    class="absolute z-30 mt-1 w-full max-h-56 overflow-y-auto rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-xl custom-scrollbar">
    <div *ngIf="loading" class="px-4 py-3 text-sm text-slate-400 flex items-center gap-2">
      <span class="w-4 h-4 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></span>
      กำลังโหลด...
    </div>
    <button *ngFor="let opt of options" type="button" (mousedown)="$event.preventDefault(); selectOption(opt)"
      class="w-full text-left px-4 py-2.5 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors border-b border-slate-50 dark:border-slate-800 last:border-b-0">
      <div class="text-sm font-medium text-slate-700 dark:text-slate-200">{{ opt.label }}</div>
      <div *ngIf="opt.subLabel" class="text-xs text-slate-400">{{ opt.subLabel }}</div>
    </button>
    <div *ngIf="!loading && options.length === 0" class="px-4 py-3 text-sm text-slate-400">ไม่พบรายการ</div>
  </div>
</div>
